import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className="ri-film-line text-2xl" aria-hidden="true"></i>
      </span>
      <h1 className="mt-5 font-heading text-2xl font-bold text-foreground-950">页面走丢了</h1>
      <p className="mt-2 max-w-sm text-sm leading-relaxed text-foreground-600">
        这个地址可能已经调整，或者从来没有存在过。回到首页继续逛逛吧。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-primary-800 px-5 py-2.5 text-sm text-background-50 whitespace-nowrap cursor-pointer hover:bg-primary-700"
        >
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 whitespace-nowrap cursor-pointer hover:border-primary-300 hover:text-primary-700"
        >
          浏览电影
        </Link>
      </div>
    </div>
  );
}